"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipTextWrapper = exports.TooltipIconWrapper = exports.LinkTextWrapper = exports.TruncatedText = exports.CellIcon = exports.GridRoot = exports.GridBody = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const components_1 = require("@veeam/components");
exports.GridBody = styled_components_1.default(components_1.View).attrs({
    contentMod: components_1.VIEW_CONTENT_MOD.fill,
}) `
  flex: 1;
  position: relative;
  min-height: 0;

  ${({ height }) => height &&
    styled_components_1.css `
      height: ${height}px;
    `}
`;
exports.GridBody.displayName = 'GridBody';
exports.GridRoot = styled_components_1.default(components_1.StackView).attrs({
    direction: components_1.STACK_DIRECTION.column,
    align: components_1.STACK_ALIGN.fill,
}) `
  flex: 1;
  align-self: stretch;
  max-width: 100%;
  height: 100%;
`;
exports.GridRoot.displayName = 'GridRoot';
exports.CellIcon = styled_components_1.default(components_1.Icon) `
  margin-right: ${({ theme }) => theme.spacing.s};
  vertical-align: bottom;
`;
exports.CellIcon.displayName = 'CellIcon';
exports.TruncatedText = styled_components_1.default.div.attrs({}) `
  float: ${({ justify }) => (justify === components_1.GRID_COLUMN_HEADER_JUSTIFY.right ? 'right' : 'left')};
  display: block;
  width: ${({ justify }) => (justify === components_1.GRID_COLUMN_HEADER_JUSTIFY.right ? 'unset' : '100%')};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
exports.TruncatedText.displayName = 'TruncatedText';
exports.LinkTextWrapper = styled_components_1.default.div `
  > * {
    color: ${({ theme }) => theme.colorLink};
  }
`;
exports.LinkTextWrapper.displayName = 'LinkTextWrapper';
exports.TooltipIconWrapper = styled_components_1.default.div `
  position: absolute;
`;
exports.TooltipIconWrapper.displayName = 'TooltipIconWrapper';
exports.TooltipTextWrapper = styled_components_1.default.div.attrs({}) `
  ${({ withIcon, theme }) => withIcon &&
    styled_components_1.css `
      margin-left: ${theme.spacing.l};
    `}
`;
exports.TooltipTextWrapper.displayName = 'TooltipTextWrapper';
//# sourceMappingURL=Layouts.js.map